import { Pill } from "@clipboard-health/ui-components";
import { type Theme } from "@mui/material";
import { InterviewStatus } from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";

interface InterviewStatusPillProps {
  status: InterviewStatus;
}

const statusConfig = {
  [InterviewStatus.BOOKED]: {
    label: "Booked",
    backgroundColor: (theme: Theme) => theme.palette.intent?.success.background,
    color: (theme: Theme) => theme.palette.intent?.success.text,
  },
  [InterviewStatus.CANCELLED]: {
    label: "Cancelled",
    backgroundColor: (theme: Theme) => theme.palette.intent?.warning.background,
    color: (theme: Theme) => theme.palette.intent?.warning.text,
  },
  [InterviewStatus.RESCHEDULED]: {
    label: "Rescheduled",
    backgroundColor: (theme: Theme) => theme.palette.intent?.warning.background,
    color: (theme: Theme) => theme.palette.intent?.warning.text,
  },
  [InterviewStatus.ATTENDANCE_CONFIRMED]: {
    label: "Attendance Confirmed",
    backgroundColor: (theme: Theme) => theme.palette.intent?.neutral.background,
    color: (theme: Theme) => theme.palette.intent?.neutral.text,
  },
  [InterviewStatus.NO_CALL_NO_SHOW]: {
    label: "No Call No Show",
    backgroundColor: (theme: Theme) => theme.palette.intent?.error.background,
    color: (theme: Theme) => theme.palette.intent?.error.text,
  },
};

export function InterviewStatusPill(props: InterviewStatusPillProps) {
  const { status } = props;
  const config = statusConfig[status];

  return (
    <Pill
      label={config.label}
      variant="filled"
      size="small"
      backgroundColor={config.backgroundColor}
      color={config.color}
    />
  );
}
